<template>
    <v-col>
        <div class="wrap-head-detail">
            <v-btn class="btn-back" elevation="0" text @click="$router.go(-1)">
                <v-icon size="18">mdi-arrow-left</v-icon>
                {{ $t("global.back") }}
            </v-btn>

            <div class="wrap-head-btn">
                <h1>{{ $t("sites.new_site") }}</h1>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_sites">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("sites.info_site") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="designation"
                                    :label="$t('sites.designation')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="code"
                                    :label="$t('sites.code')"
                                    counter
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12" md="6">
                            <h2>{{ $t("sites.models_codes") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                        <v-col class="text-lg-right" cols="12" md="6">
                            <v-btn
                                color="secondary"
                                class="btn-add"
                                elevation="0"
                                @click="showNewCodeModelForm = true"
                            >
                                <v-icon size="18">mdi-plus</v-icon>
                                Ajouter
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12">
                                <v-data-table
                                    :headers="headers"
                                    :items="models"
                                    :items-per-page="-1"
                                    hide-default-footer
                                >
                                    <template #[`item.actions`]="{item}">
                                        <v-btn
                                            class="delete ma-1"
                                            icon
                                            small
                                            dark
                                            @click="deleteModel(item.code)"
                                        >
                                            <v-icon size="16">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </div>
                </div>
                <v-btn :loading="loading"
                       color="primary"
                       elevation="0"
                       @click="create"
                >
                    {{ $t("global.save") }}
                </v-btn>
            </v-form>
        </div>
        <new-code-model
            :visible="showNewCodeModelForm"
            @close="showNewCodeModelForm = false"
            @modelCreated="addModel"
        >
        </new-code-model>
    </v-col>
</template>

<script>
import NewCodeModel from "./new_code_model";

export default {
    name: "NewSite",
    components: {NewCodeModel},

    data() {
        return {
            designation: "",
            code: "",
            headers: [
                {
                    text: this.$t("sites.code"),
                    align: "start",
                    sortable: true,
                    value: "code",
                },
                {
                    text: this.$t("global.actions"),
                    align: "center",
                    sortable: false,
                    value: "actions",
                },
            ],
            models: [],
            showNewCodeModelForm: false,
            loading: false
        };
    },

    methods: {
        async create() {
            try {
                this.loading = true
                const site = await this.createSite()
                this.models.forEach((model) => {
                    this.createModel(site.id, model)
                })
                this.loading = false
                await this.$router.push({name: 'sites'})
            } catch (e) {
                this.loading = false
            }
        },
        async createSite() {
            return (await this.$api.sites.create({
                code: this.code,
                label: this.designation
            })).data
        },
        async createModel(id, model) {
            await this.$api.site_model_number.create(id, model)
        },
        addModel(model) {
            this.models.push(model)
        },
        async deleteModel(code) {
            this.models = this.models.filter(function (model) {
                return model.code !== code
            })
        },
    },
};
</script>
